import { ASSIGN_SERVICE_PROVIDER, ASSIGN_SERVICE_PROVIDER_FAILURE, ASSIGN_SERVICE_PROVIDER_SUCCESS, DISPUTE_DETAIL, DISPUTE_DETAIL_FAILURE, DISPUTE_DETAIL_SUCCESS, EXPORT_DISPUTES, EXPORT_DISPUTES_FAILURE, EXPORT_DISPUTES_SUCCESS, EXPORT_JOBS, EXPORT_JOBS_FAILURE, EXPORT_JOBS_SUCCESS, GET_DISPUTES, GET_DISPUTES_FAILURE, GET_DISPUTES_SUCCESS, GET_JOBS, GET_JOBS_FAILURE, GET_JOBS_SUCCESS, GET_SERVICE_PROVIDERS, GET_SERVICE_PROVIDERS_FAILURE, GET_SERVICE_PROVIDERS_SUCCESS, JOB_DETAIL, JOB_DETAIL_FAILURE, JOB_DETAIL_SUCCESS } from "../constants";

const initialState = {
    isLoading: false,
    allJobs: [],
    jobsDetail: {},
    serviceProviders: [],
    serviceProvidersLoading: false,
    assignServiceProviderLoading: false
}

export default function jobReducer(state = initialState, action) {
    switch (action.type) {
        case GET_JOBS:
            state = {
                ...state,
                isLoading: true,
                allJobs: [],
            };
            break;
        case GET_JOBS_SUCCESS:
            state = {
                ...state,
                isLoading: false,
                allJobs: action.payload,
            };
            break;
        case GET_JOBS_FAILURE:
            state = {
                ...state,
                isLoading: false,
                allJobs: [],
            };
            break;
        case EXPORT_JOBS:
            state = {
                ...state,
            };
            break;
        case EXPORT_JOBS_SUCCESS:
            state = {
                ...state,
            };
            break;
        case EXPORT_JOBS_FAILURE:
            state = {
                ...state,
            };
            break;
        case JOB_DETAIL:
            state = {
                ...state,
                isLoading: true,
                jobsDetail: {}
            };
            break;
        case JOB_DETAIL_SUCCESS:
            state = {
                ...state,
                isLoading: false,
                jobsDetail: action.payload
            };
            break;
        case JOB_DETAIL_FAILURE:
            state = {
                ...state,
                isLoading: false,
                jobsDetail: {}
            };
            break;
        case GET_SERVICE_PROVIDERS:
            // alert("get service provider reducer")

            state = {
                ...state,
                serviceProvidersLoading: true,
                serviceProviders: {}
            };
            break;
        case GET_SERVICE_PROVIDERS_SUCCESS:
            // alert('get service provider success reducer')
            // console.log("get service provider success payload",action.payload)
            state = {
                ...state,
                serviceProvidersLoading: false,
                serviceProviders: action.payload
            };
            break;
        case GET_SERVICE_PROVIDERS_FAILURE:
            // alert('get service provider fail reducer')
            state = {
                ...state,
                serviceProvidersLoading: false,
                serviceProviders: []
            };
            break;
        case ASSIGN_SERVICE_PROVIDER:
            // alert("get service provider reducer")

            state = {
                ...state,
                assignServiceProviderLoading: true,
            };
            break;
        case ASSIGN_SERVICE_PROVIDER_SUCCESS:
            // alert('get service provider success reducer')
            // console.log("get service provider success payload",action.payload)
            state = {
                ...state,
                assignServiceProviderLoading: false,
            };
            break;
        case ASSIGN_SERVICE_PROVIDER_FAILURE:
            // alert('get service provider fail reducer')
            state = {
                ...state,
                assignServiceProviderLoading: false,
            };
            break;
        default:
            break;
    }
    return state

}